<script setup lang="ts">
import { Button } from '~/components/ui/button'

const props = defineProps({
  icon: Boolean,
  className: String,
  title: String,
  startIcon: String
});

</script>

<template>
  <Button :class="className || 'ys-button hover:text-amber-50'" as-child>
    <NuxtLink :to="{name: 'auth'}">
      <Icon v-if="props.startIcon" size="18" class="ml-1" :name="props.startIcon"/>
      {{ props.title || $t("Join") }}
      <Icon v-if="props.icon" size="18" class="ml-1" name="ri:user-line"/>
    </NuxtLink>
  </Button>
</template>